<template>
  <div class="home-content">
    <div class="head-pard" v-if="!!userInfo">
      <div @click="util.topage('mine')"><img :src="userInfo.ico_picture_img" /></div>
      <span>Home</span>
      <div class="header_moeny">
        <p style="font-weight: normal; font-size: 0.32rem;">{{ userInfo.money }}</p>
        <div :class="on_Refresh ? 'refresh rotate' : 'refresh'" @click="Refresh">
          <img src="@/assets/images/icon/refresh_ccw_icon_251074.png" alt="">
        </div>
      </div>
    </div>
    <div class="bananer">
      <div class="swiper-container" ref="banner">
        <div class="swiper-wrapper" v-if="news_banner.length > 0">
          <div class="swiper-slide cursor" v-for="(item, index) in news_banner" :key="index">
            <img class="swiper-img" :src="!item.picture_url ? '' : item.picture_url">
          </div>
        </div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-prev">
          <img src="@/assets/images/base/ic_left.png" />
        </div>
        <div class="swiper-button-next">
          <img src="@/assets/images/base/ic_right.png" />
        </div>
      </div>
    </div>
    <div class="first-pard">
      <div class="one" :class="i.rate >= 0 ? 'b-down' : 'b-up'" v-for="(i, index) in list1" v-bind:key="index"
        @click="util.topage('kline', i.name, i.name_2)">
        <div style="font-weight: bold;">{{ i.name }}/USDT</div>
        <div :class="i.rate >= 0 ? 'green' : 'red'">{{ i.now_price }}</div>
        <div :class="i.rate >= 0 ? 'green' : 'red'">{{ i.rate }}%</div>
      </div>
    </div>
    <div class="second-pard">
      <img v-if="!!home_center_at" :src="home_center_at" />
    </div>
    <div class="third-pard">
      <ul>
        <li @click="sortPrice('name')">Currency<div class="red">{{ sortTo['name'] }}</div>
        </li>
        <li @click="sortPrice('now_price')">Real Price<div class="red">{{ sortTo['now_price'] }}</div>
        </li>
        <li @click="sortPrice('rate')">Rise Fall<div class="red">{{ sortTo['rate'] }}</div>
        </li>
      </ul>
      <ul v-for="(i, index) in list" v-bind:key="index" @click="util.topage('kline', i.name, i.name_2)">
        <li class="name">
          <img :class="(i.name == 'UNI' || i.name == 'XAUT') ? 'spe' : ''" :src="i.coin_img" />
          <div>{{ i.name }}/USDT</div>
        </li>
        <li :class="i.rate >= 0 ? 'green' : 'red'">{{ i.now_price }}</li>
        <li>
          <div :class="i.rate >= 0 ? 'change down' : 'change up'">{{ i.rate }}%</div>
        </li>
      </ul>
    </div>
    <FootMenu />
    <van-loading v-show="showloding" size="50px" color="#1989fa" vertical />
  </div>
</template>
<script>
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
import FootMenu from "@/coms/footmenu.vue";
export default {
  components: {
    FootMenu
  },
  data() {
    return {
      userInfo: this.util.user,
      news_banner: [],
      home_center_at: "",
      list: [],
      list1: [],
      showloding: false,
      sortParam: {},
      sortAsc: { name: true, now_price: true, rate: true },
      sortTo: { name: "", now_price: "", rate: "" },
      timer: null,
      on_Refresh: false
    };
  },
  watch: {
    $route(to) {
      if (to.path == "/home" && this.list.length > 0) {
        this.swiper.destroy(false);
        this.util.timeOut1 = setTimeout(() => {
          this.createdSwiper();
        }, 300);
      }
    }
  },
  methods: {
    Refresh() {
      this.on_Refresh = true
      this.util.refreshUserInfo((res) => {
        this.on_Refresh = false
      });
    },
    findConfig() {
      this.showloding = true;
      this.axios.get(this.api.api_findOneConfigByKeyName, {
        params: { key_name: "home_center_at" }
      })
        .then((res) => {
          this.showloding = false;
          if (res.data.code == 0) {
            this.home_center_at = res.data.data.key_value;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //创建轮播图
    createdSwiper() {
      // eslint-disable-next-line no-undef
      this.swiper = new Swiper(this.$refs.banner, {
        loop: true,
        pagination: {
          el: ".swiper-pagination"
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        }
      });
    },
    getBanner() {
      let params = { category: 1 }
      params.pageNo = this.pageNo;
      params.pageSize = this.pageSize;
      if (!params.hasOwnProperty("category")) return false;
      this.axios.get(this.api.api_findNotices, { params: params }).then(res => {
        this.getGains();
        this.showloding = false;
        if (res.data.code == 0) {
          let list = res.data.data.map(item => {
            return {
              picture_url: item.picture_url,
            }
          })
          if (list.length > 0) {
            this.news_banner = list;
            this.util.timeOut2 = setTimeout(() => {
              this.createdSwiper();
            }, 300);
          }
        } else {
          this.util.checkToken(res.data.message);
        }
      }).catch((err) => {
        console.log(err)
      });
    },
    sortPrice(key) {
      let asc = this.sortAsc[key];
      this.sortTo = { name: "", now_price: "", rate: "" };
      if (asc) this.sortTo[key] = "↑";
      else this.sortTo[key] = "↓";
      this.sortParam = { key: key, asc: asc };
      this.sortAsc[key] = !asc;
      this.list = this.util.objArraySort(this.list, this.sortParam);
    },
    getGains() {
      let set_data = {
        flag: 1,
        sortName: 0,
        sort: 0,
        userName: this.util.user.login_name,
        userToken: this.util.user.token
      }
      this.axios.get(this.api.api_findNowPriceGains, {
        params: {
          ...set_data,
          dn_value: this.util.get_dn_value(set_data)
        }
      }).then(res => {
        this.showloding = false;
        if (res.data.code == 0) {
          let new_data
          let list = res.data.data.map(item => {
            if (item.name == 'bch') new_data = item
            if (item.name == 'btg') {
              return {
                name: item.name.toUpperCase(),
                name_2: 'bch',
                now_price: new_data.now,
                coin_img: require('@/assets/images/coin/' + item.name.toUpperCase() + '.png'),
                rate: parseFloat(new_data.rate).toFixed(2),
              }
            } else {
              return {
                name: item.name.toUpperCase(),
                name_2: item.name.toUpperCase(),
                now_price: item.now,
                coin_img: require('@/assets/images/coin/' + item.name.toUpperCase() + '.png'),
                rate: parseFloat(item.rate).toFixed(2),
              }
            }
          })
          this.list1 = list;
          this.list = this.util.objArraySort(list, this.sortParam);
          let currentPath = this.$route.path;
          if (currentPath == '/home') {
            this.timer = setTimeout(() => {
              if (this.util.isLogin()) { this.getGains(); }
            }, this.util.refreshTime);
          } else {
            window.clearTimeout(this.timer)
          }
        } else {
          this.util.checkToken(res.data.message);
        }
      }).catch(() => {
        console.log("Your current network is unstable. Please optimize the network.");
      });
    },
  },
  mounted() {
    this.findConfig();
    if (this.util.isLogin()) {
      this.userInfo = this.util.user;
      this.getBanner();
    }
  },
  destroyed() {
    window.clearTimeout(this.timer)
  },
  
};
</script>
<style lang="scss" scoped>
.home-content {
  font-size: 0.32rem;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  background: rgb(235, 235, 235);
  color: black;
  width: 100%;
  height: 100%;

  .head-pard {
    height: 40px;
    display: grid;
    grid-template-columns: 40% 1fr 40%;
    height: 36px;
    align-items: center;
    text-align: center;
    font-size: 0.36rem;
    font-weight: bold;
    color: black;
    position: relative;

    :nth-child(1) {
      text-align: left;
      display: flex;
      align-items: center;

      img {
        padding: 0;
        display: block;
        border-radius: 100%;
        border: 1.8px solid #628808;
        display: block;
        width: 36px;
        height: 36px;
        margin-left: 4%;
      }
    }

    .header_moeny {
      height: 100%;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      display: flex;
      justify-content: left;
      align-items: center;

      .refresh {
        width: 0.4rem;
        height: 0.4rem;
        margin-left: 5px;

        img {
          width: 100%;
          height: 100%;
          padding: 0;
          margin: 0;
        }
      }

      .rotate {
        animation: rotate .3s linear infinite;
      }

      p {
        color: #000;
      }

      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(360deg);
        }
      }
    }

    :nth-child(3) {
      font-size: 0.34rem;
      text-align: right;
      padding-right: 4%;
    }
  }

  .bananer {
    .swiper-img {
      width: 100%;
      height: 200px;
    }

    .swiper-button-next {
      width: 30px;
      height: 30px;
      background: none;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .swiper-button-prev {
      width: 30px;
      height: 30px;
      background: none;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .first-pard {
    overflow-x: scroll;
    margin: 4px auto;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .one {
      border-radius: 10px/10px;
      background: white;
      margin: auto 2px;
      width: 120px;
      padding: 10px 10px;
      text-align: center;

      :first-child {
        font-size: 0.32rem;
      }
    }

    .b-up {
      border: 2px solid #f6543e;
    }

    .b-down {
      border: 2px solid #628808;
    }
  }

  .second-pard {
    width: 100%;
    height: 120px;
    border-radius: 10px/10px;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      display: block;
      margin: auto 0;
      height: 120px;
      width: 100%;
    }
  }

  .third-pard {
    margin: 0 auto;
    margin-bottom: 50px;
    width: 100%;
    background: white;
    text-align: center;

    ul:first-child {
      display: flex;
      height: 40px;
      background: white;
      color: black;
      font-weight: bolder;
      font-size: 0.32rem;

      li {
        width: 110px;
        padding: 10px;
        display: flex;
      }

      :nth-child(2) {
        display: flex;
        justify-content: center;
      }

      :nth-child(3) {
        display: flex;
        justify-content: right;
      }

      // border-bottom: 1px solid rgb(235, 235, 235);
    }

    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      font-size: 0.32rem;

      .name {
        display: flex;
        align-items: center;
        width: 80px;
        font-size: 0.32rem;

        img {
          display: block;
          margin: auto 6px;
          width: 34px;
        }

        .spe {
          border: solid 1px rgb(193, 193, 193);
          border-radius: 50%;
        }
      }

      li .change {
        margin-right: 5px;
        width: 80px;
        padding: 5px;
        height: 30px;
        border-radius: 4px/4px;
        font-size: 0.32rem;
      }
    }
  }
}
</style>